import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import {
  MenuItem
} from 'components/Menu'
import Button from 'components/Button'
import ActivityContent from 'components/ActivityContent'
import classes from './NotificationContent.module.scss'

class NotificationContent extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    wasRead: PropTypes.bool.isRequired,

    requestMarkNotificationAsRead: PropTypes.func.isRequired,
    requestMarkNotificationAsUnread: PropTypes.func.isRequired
  }

  handleMarkAsReadClick = () => {
    const {
      id,

      requestMarkNotificationAsRead
    } = this.props

    requestMarkNotificationAsRead({ id })
  }

  handleMarkAsUnreadClick = () => {
    const {
      id,

      requestMarkNotificationAsUnread
    } = this.props

    requestMarkNotificationAsUnread({ id })
  }

  render () {
    const {
      id,
      wasRead,

      requestMarkNotificationAsRead,
      requestMarkNotificationAsUnread,

      ...props
    } = this.props

    return (
      <ActivityContent
        {...props}
        id={id}
        wasRead={wasRead}
        actions={
          !wasRead && (
            <Button
              bsStyle='warning'
              className={classes.markAsRead}
              icon={<KanBoIcon fixedWidth name='kanbo-16-tasks' />}
              onClick={this.handleMarkAsReadClick}
            />
          ) 
        }
        menu={
          wasRead && (
            <MenuItem
              icon={<KanBoIcon fixedWidth name='kanbo-16-mark-as-unread' />}
              onClick={this.handleMarkAsUnreadClick}
            >
              <FormattedMessage id='NOTIFICATIONS_MARK_AS_UNREAD' />
            </MenuItem>
          )
        }
      />
    )
  }
}

export default NotificationContent
